import React from 'react';
import { useTranslation } from 'react-i18next';
import { thousand } from '../../../functions';

// Spells out what a percentage is actually comparing. A bare "-22.8%" tells you
// the direction but not the two figures behind it, which is the first thing
// anyone asks when a number looks wrong.
function ComparisonHint({
  currentLabel,
  currentValue,
  previousLabel,
  previousValue,
}) {
  const { t } = useTranslation();
  const diff = (Number(currentValue) || 0) - (Number(previousValue) || 0);

  return (
    <div className="text-xs tabular-nums" style={{ minWidth: '12rem' }}>
      <div className="flex justify-between gap-4">
        <span className="opacity-80">{currentLabel}</span>
        <span className="font-semibold">{thousand(currentValue)}</span>
      </div>
      <div className="flex justify-between gap-4">
        <span className="opacity-80">{previousLabel}</span>
        <span>{thousand(previousValue)}</span>
      </div>
      <div className="mt-1 flex justify-between gap-4 border-t border-white/25 pt-1">
        <span className="opacity-80">{t('difference')}</span>
        <span className="font-semibold">
          {diff >= 0 ? '+' : ''}{thousand(diff)}
        </span>
      </div>
    </div>
  );
}

export default ComparisonHint;
